import React, { useState, useRef, useCallback } from 'react';
import './UploadFile.scss';
import { Upload, X, File, Image, FileText, Video, Music } from 'lucide-react';
import axios from 'axios';
import { getToken } from '../../auth/authConfig';
import { Button } from 'react-bootstrap';

function UploadFile({formId,getFormListDetails}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);
  const [loading,setLoading]= useState(false)
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedFile(null);
    setDragOver(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    setDragOver(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setDragOver(false);
  }, []);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      setSelectedFile(files[0]);
    }
  }, []);

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setSelectedFile(files[0]);
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  const getFileIcon = (file) => {
    const fileType = file.type;
    if (fileType.includes('pdf')) return <FileText className="icon pdf" />;
    return <File className="icon default" />;
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // const handleUpload = () => {
  //   if (selectedFile) {
  //     console.log(`Uploading file: ${selectedFile}`);
  //     alert(`File "${selectedFile.name}" uploaded successfully!`);
  //     closeModal();
  //   }
  // };

  const handleUpload = async () => {
    if (selectedFile) {

      try {
        const token = await getToken();
        const getuploadurl = `${process.env.REACT_APP_SERVER_URL}/api/certificate/upload-certificate`;
        setLoading(true)
        const formData = new FormData();
        formData.append("form_id", `${formId}`); // Make sure `id` is defined in your component
        formData.append("file", selectedFile);

        
  
        const response = await axios.post(getuploadurl, formData, {
          headers: {
            "oidc-token": token,
            "Content-Type": "multipart/form-data"
          },
        });
  
        if(response.status === 200){
          setLoading(false)
          console.log('Server response:', response.data);
          getFormListDetails()
          closeModal();

        }
      } catch (error) {
        console.error('Upload failed:', error);
        setLoading(false)
        alert('Failed to upload file.');
      }
    }
  };
  

  return (
    <div className="">
      <Button onClick={openModal}>
        <div className="upload-content ">
          <span>Upload</span>
        </div>
        <div className="upload-overlay" />
      </Button>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div className="modal-header">
              <h2>Upload File</h2>
              <button onClick={closeModal} className="close-btn">
                <X />
              </button>
            </div>

            <div className="modal-content">
              <div
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                className={`drop-zone ${dragOver ? 'drag-over' : ''} ${selectedFile ? 'file-selected' : ''}`}
              >
                {selectedFile ? (
                  <div className="file-preview">
                    {getFileIcon(selectedFile)}
                    <p className="file-name">{selectedFile.name}</p>
                    <p className="file-size">{formatFileSize(selectedFile.size)}</p>
                    <button
  onClick={() => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Reset input so same file can be re-uploaded
    }
  }}
  className="remove-btn"
>
  Remove file
</button>                  </div>
                ) : (
                  <div className="drop-placeholder">
                    <Upload className={`placeholder-icon ${dragOver ? 'highlight' : ''}`} />
                    <p className="drop-text">{dragOver ? 'Drop your file here' : 'Drag and drop your file here'}</p>
                    <p className="drop-subtext">or click to browse from your computer</p>
                    <button onClick={handleBrowseClick} className="browse-btn">Browse Files</button>
                  </div>
                )}
              </div>

              <input
                ref={fileInputRef}
                type="file"
                onChange={handleFileSelect}
                className="hidden-input"
                accept="application/pdf,.pdf"
                />

              <div className="file-info">
                <div><strong>Supported formats:</strong> All file types supported. Max: 2MB</div>
              </div>
            </div>

            <div className="modal-footer">
              <button onClick={closeModal} className="cancel-btn">Cancel</button>
              <button onClick={handleUpload} className="confirm-btn" disabled={!selectedFile || loading}>
                 {loading ? 'Uploading...': "Upload Certificate"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UploadFile;
